import 'css-chunksrc/client/pages/projectPage/wbsPage/statuses/tasks/task/allocationsList/styles.scss';export default {
  "allocationsList": "_allocationsList_1v3w7_1",
  "list": "_list_1v3w7_5",
  "main": "_main_1v3w7_12",
  "allocation": "_allocation_1v3w7_1",
  "summary": "_summary_1v3w7_28",
  "resourcesList": "_resourcesList_1v3w7_37",
  "quickAllocationMenu": "_quickAllocationMenu_1v3w7_44",
  "overlay": "_overlay_1v3w7_50",
  "menu": "_menu_1v3w7_68",
  "addAllocationIcon": "_addAllocationIcon_1v3w7_72"
};